export const RecordBy = {
  NO_OF_HOUSEHOLD: '0',
  WEIGHT: '1',
  ITEMS: '2',
  USAGE: '3'
};

export const Status = {
  ACTIVE: 1,
  INACTIVE: 0
};
